/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentHasBudget = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
};